import { lazy } from "react";

export const TermsAndCondition = lazy(
  () => import("./TermsAndCondition/TermsAndCondition"),
);
export const PrivacyPolicy = lazy(
  () => import("./PrivacyPolicy/PrivacyPolicy"),
);
export const AboutUs = lazy(() => import("./AboutUs/AboutUs"));

// auth
export const Login = lazy(() => import("./LoginV2/Login"));
export const Registration = lazy(
  () => import("./RegistrationV2/Registration"),
);
export const Otp = lazy(() => import("./OtpV2/Otp"));
export const ForgotPassword = lazy(
  () => import("./ForgotPassword/ForgotPassword"),
);
export const ForgotPasswordSuccess = lazy(
  () => import("./ForgotPasswordSuccess/ForgotPasswordSuccess"),
);
export const NewPassword = lazy(
  () => import("./NewPassword/NewPassword"),
);
export const ProfileSetup = lazy(
  () => import("./RegistrationV2/ProfileSetup/ProfileSetup"),
);

export const Home = lazy(() => import("./HomeV2/Home"));
export const Products = lazy(() => import("./Products/Products"));
export const ProductVariants = lazy(
  () => import("./Products/ProductVariants"),
);
export const Categories = lazy(
  () => import("./Categories/Categories"),
);
export const Brands = lazy(() => import("./Brands/Brands"));
export const ProductsByBrand = lazy(
  () => import("./ProductsByBrand/ProductsByBrand"),
);
export const ProductByCategory = lazy(
  () => import("./ProductByCategory/ProductByCategory"),
);
export const ProductSinglePage = lazy(
  () => import("./ProductSinglePage/ProductSinglePage"),
);
export const Cart = lazy(() => import("./Cart/Cart"));
export const Checkout = lazy(() => import("./Checkout/Checkout"));
export const OrderCompleted = lazy(
  () => import("./OrderCompleted/OrderCompleted"),
);
export const OrderCompletedPrint = lazy(
  () => import("./OrderCompletedPrint/OrderCompletedPrint"),
);
export const BestSellingProducts = lazy(
  () => import("./BestSellingProducts/BestSellingProducts"),
);
export const BestDealsProducts = lazy(
  () => import("./BestDealsProducts/BestDealsProducts"),
);
export const SearchProducts = lazy(
  () => import("./SearchProducts/SearchProducts"),
);

export const NotFound = lazy(() => import("./404/NotFound"));

// enterprise
export const EnterpriceHome = lazy(
  () => import("./EnterpriceHome/EnterpriceHome"),
);
export const EnterpriseSetup = lazy(
  () => import("./EnterpriseSetup/EnterpriseSetup"),
);
export const EnterpriseOtp = lazy(
  () => import("./EnterpriseSetup/EnterpriseOtp/EnterpriseOtp"),
);
export const PhoneVerifySuccess = lazy(
  () => import("./PhoneVerifySuccess/PhoneVerifySuccess"),
);

//
export const StoreRegistration = lazy(
  () => import("./StoreRegistration/StoreRegistration"),
);
export const BusinessInfomation = lazy(
  () => import("./BusinessInformation/BusinessInformation"),
);
export const BusinessInfomationV2 = lazy(
  () =>
    import("./RegistrationV2/BusinessInformationV2/BusinessInformation"),
);
export const BusinessInfoUpload = lazy(
  () => import("./BusinessInfoUpload/BusinessInfoUpload"),
);
export const BankInfomation = lazy(
  () => import("./BankInformation/BankInformation"),
);
export const Builder360 = lazy(
  () => import("./Builder360/Builder360"),
);
export const PaymentSuccessful = lazy(
  () => import("./PaymentSuccessful/PaymentSuccessful"),
);

//
export const BuyerUnauthPaymentCompleted = lazy(
  () =>
    import("./BuyerUnauthPaymentCompleted/BuyerUnauthPaymentCompleted"),
);

export const CBcast = lazy(() => import("./CBcast/CBcast"));
export const CBcastDetail = lazy(
  () => import("./CBcast/CBcastDetail/CBcastDetail"),
);
export const Resources = lazy(() => import("./Resources/Resources"));
export const ResourcesDetails = lazy(
  () => import("./Resources/ResourcesDetails/ResourcesDetails"),
);

export const EmailVerifySuccess = lazy(
  () => import("./EmailVerifySuccess/EmailVerifySuccess"),
);